interface Idialog {
    url: string,
    positionType?: 'top' | 'bottom' | 'left' | 'right' | 'center'
    style?: Partial<CSSStyleDeclaration>
    isCanClose?: number
    closeFn?(): void
}

import index from './Index.vue'
import useShowComponent from '@/hooks/uesShowComponent'
const {show, hide} = useShowComponent('urlPopup', index)
const showUrlPopup = (obj: Idialog) => show(obj)
const hideUrlPopup = hide
export {
    showUrlPopup,
    hideUrlPopup
}